import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import applyReducer from './applyReducer';
import { constantsRegistry } from '../constants/tableConstantsFactory';
const dashboardConstants = constantsRegistry('dashboard');
const initState = {
  availableCharts: [],
  charts: {},
  jobs: [],
  loaded: false,
  permissions: {
    view: {
      include: ['dashboard']
    }
  },
  start: null,
  stop: null
};
const loadResults = (state, _ref) => {
  let data = _ref.data;
  return _objectSpread(_objectSpread({}, state), {}, {
    availableCharts: data.availableCharts,
    charts: data.charts,
    loaded: true,
    start: data.start,
    stop: data.stop
  });
};
const reducers = {
  [dashboardConstants.INDEX_SUCCESS]: loadResults
};
export default applyReducer(reducers, initState);